module.exports = __webpack_public_path__ + "static/media/campo-basket-alto-noleggiocampi.d70bfb58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/basket/slider1/campo-basket-alto-noleggiocampi.jpg
// module id = 631
// module chunks = 0